import React, { Component } from "react";
import LoggedOutFrame from "../../lib/logged_out_frame";
import { Col } from "react-bootstrap";

export default class PasswordSent extends Component {
  render() {
    return (
      <LoggedOutFrame>
        <Col md={6} mdOffset={3} sm={12}>
          <h1 className="sign-in-page__header">Password Reset link Sent!</h1>
          <p className="sign-in-page__welcome">
            Your password link has been sent. Look out for an email from RedCircle, which will guide
            you through the next steps.
          </p>
        </Col>
      </LoggedOutFrame>
    );
  }
}
